import { render, staticRenderFns } from "./PersonalCenter.vue?vue&type=template&id=4593b856&scoped=true"
import script from "./PersonalCenter.vue?vue&type=script&lang=js"
export * from "./PersonalCenter.vue?vue&type=script&lang=js"
import style0 from "./PersonalCenter.vue?vue&type=style&index=0&id=4593b856&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4593b856",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4593b856')) {
      api.createRecord('4593b856', component.options)
    } else {
      api.reload('4593b856', component.options)
    }
    module.hot.accept("./PersonalCenter.vue?vue&type=template&id=4593b856&scoped=true", function () {
      api.rerender('4593b856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/PersonalCenter.vue"
export default component.exports